import { Box } from 'grommet';
import styled from 'styled-components';

export const NotificationsListItemWrapper = styled(Box)`
	flex: 1 0 70px;
	&:hover {
		background: ${({ theme }) => theme?.global?.colors?.brandLight};
	}
`;
